import { render, staticRenderFns } from "./TenderListCell.vue?vue&type=template&id=0c037c6c&"
import script from "./TenderListCell.vue?vue&type=script&lang=js&"
export * from "./TenderListCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports